/**
 * Utilitários para processar dados do Chatwoot
 */

/**
 * Extrai o código do cliente dos dados do Chatwoot
 * @param data Dados brutos do Chatwoot
 * @returns Código do cliente ou null se não encontrado
 */
export function extrairCodigoCliente(data: any): number | null {
  try {
    // Verificar se os dados são válidos
    if (!data) return null;
    
    console.log('Tentando extrair código do cliente dos dados:', JSON.stringify(data).substring(0, 200) + '...');
    
    // Verificar se é uma string JSON e tentar fazer parse
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) {
        console.error('Erro ao fazer parse dos dados JSON:', e);
      }
    }
    
    // Formato padrão do Chatwoot Dashboard App conforme documentação
    if (data.event === 'appContext') {
      // Caminho principal conforme documentação
      if (data.data?.contact?.custom_attributes?.codcli) {
        const codCli = Number(data.data.contact.custom_attributes.codcli);
        console.log('Código do cliente encontrado em data.data.contact.custom_attributes.codcli:', codCli);
        return !isNaN(codCli) ? codCli : null;
      }
      
      // Caminho alternativo no objeto conversation
      if (data.data?.conversation?.meta?.sender?.custom_attributes?.codcli) {
        const codCli = Number(data.data.conversation.meta.sender.custom_attributes.codcli);
        console.log('Código do cliente encontrado em data.data.conversation.meta.sender.custom_attributes.codcli:', codCli);
        return !isNaN(codCli) ? codCli : null;
      }
    }
    
    // Formato direto (pode acontecer em alguns casos)
    if (data.contact?.custom_attributes?.codcli) {
      const codCli = Number(data.contact.custom_attributes.codcli);
      console.log('Código do cliente encontrado em data.contact.custom_attributes.codcli:', codCli);
      return !isNaN(codCli) ? codCli : null;
    }
    
    console.warn('Código do cliente não encontrado nos dados do Chatwoot');
    return null;
  } catch (error) {
    console.error('Erro ao extrair código do cliente:', error);
    return null;
  }
}

/**
 * Extrai informações básicas do contato dos dados do Chatwoot
 * @param data Dados brutos do Chatwoot
 * @returns Objeto com informações do contato ou null se não encontrado
 */
export function extrairInfoContato(data: any): any {
  try {
    // Verificar se os dados são válidos
    if (!data) return null;
    
    // Verificar se os dados estão no formato esperado (com data.data)
    const chatwootData = data.data || data;
    
    // Tentar extrair as informações do contato
    const contato = chatwootData.contact || {};
    
    return {
      id: contato.id,
      nome: contato.name || '',
      telefone: contato.phone_number || '',
      email: contato.email || '',
      // Adicionar outros campos conforme necessário
    };
  } catch (error) {
    console.error('Erro ao extrair informações do contato:', error);
    return null;
  }
}

/**
 * Extrai informações básicas da conversa dos dados do Chatwoot
 * @param data Dados brutos do Chatwoot
 * @returns Objeto com informações da conversa ou null se não encontrado
 */
export function extrairInfoConversa(data: any): any {
  try {
    // Verificar se os dados são válidos
    if (!data) return null;
    
    // Verificar se os dados estão no formato esperado (com data.data)
    const chatwootData = data.data || data;
    
    // Tentar extrair as informações da conversa
    const conversa = chatwootData.conversation || {};
    
    return {
      id: conversa.id,
      status: conversa.status || '',
      createdAt: conversa.created_at ? new Date(conversa.created_at * 1000) : null,
      inbox: conversa.inbox_id,
      // Adicionar outros campos conforme necessário
    };
  } catch (error) {
    console.error('Erro ao extrair informações da conversa:', error);
    return null;
  }
}
